import CustomDatatableWithSearch from '../../libs/datatables/custom_datatable_with_search'

declare const $: any

export default function initWarehousesIndex() {
  document.addEventListener('DOMContentLoaded', () => {
    const options = { disableCompactMode: true, stateSave: false }
    const indexTable = document.querySelector('#index_table')
    const searchInput = document.querySelector('#search')
    
    if (indexTable && searchInput) {
      new CustomDatatableWithSearch($(indexTable), $(searchInput), options)
    }
  })
}
